/* eslint-disable no-console */
export const makePhoneCall = (phoneNumber: string): void => {
	try {
		const cleanPhoneNumber = phoneNumber.replace(/[^\d+]/g, '');

		const telUrl = `tel:+55${cleanPhoneNumber}`;

		window.location.href = telUrl;
	} catch (error) {
		console.error('Erro ao iniciar ligação:', error);
	}
};
